import { ChatSessionsData } from 'core_main/api/sessions/types';
import { conversationCallbackFieldsFromSessionAttributes } from 'core_main/sdk/conversation_callback_from_session_attributes';
import { ConversationCallbackResponse } from '../types';

export const createGetConversationCallbackResponse = (
  session: ChatSessionsData,
): ConversationCallbackResponse => {
  const { id: conversationId } = session;
  const { createdAt, lockedAt } = session.attributes;

  return {
    conversationId,
    createdAt,
    ended: !!lockedAt,
    ...conversationCallbackFieldsFromSessionAttributes(session.attributes),
  };
};
